const errorMessages = {
  NetworkError: 'Cannot reach the server',
  Forbidden: 'No tienes permisos para acceder a este recurso',
  Unauthorized: 'Tu sesión ha expirado. Por favor, inicia sesión nuevamente.'
};

export default errorMessages;
